import {
    createDataMapper,
    transformSourceToTargetKeys,
} from '@common/utils/query/dataMappers';
import { mergeWithDefault } from '@common/utils/mergeWithDefault';
import { CLIP_KEYS } from '../constants';
import { BackendSearchClip, Clip, DEFAULT_CLIP } from '../types';
import { mapSearchMediaIdentifiers } from './media.mappers';

export const mapSearchClipToFrontend = (raw: BackendSearchClip): Clip => {
    const transformed = mergeWithDefault(
        transformSourceToTargetKeys(raw, CLIP_KEYS),
        DEFAULT_CLIP,
    );

    const availableFlags =
        raw.materialInfo_flag_onFlow || raw.materialInfo_flag_online || [];

    const flagsArray = Array.isArray(availableFlags)
        ? availableFlags
        : [availableFlags];
    const hasProxy = flagsArray.some((flag) =>
        String(flag).startsWith('PROXY;'),
    );

    const mediaIdentifiers = mapSearchMediaIdentifiers(
        raw.mediaObjectId,
        raw.moiInfo,
        availableFlags,
    );

    return {
        ...transformed,
        id: transformed.id.replace('Annotation_', ''),
        collectionId: raw.attachedEditorialObjectParentId?.[0] || '',
        mediaIdentifiers,
        hasProxy,
    };
};

export const transformClip = createDataMapper<BackendSearchClip, Clip>(
    mapSearchClipToFrontend,
    true,
);
